export const composeArrayKeysToObject = (arr: string[], value) => {
  let object = arr.reduce(
    (ac, a) => ({
      ...ac,
      [a]: value,
    }),
    {},
  );

  return object;
};

export const capitalizeFirst = (str = "") => {
  return String(str)
    .trim()
    .split(/[_\s-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};
